<template>
    <div class="dingdingWord">
        <div class="banner"></div>
        <div class="content">
            <p class="aaa">试一试在线搭建</p>
            <p class="p1">拖动组件到对应位置，生成一个“团队下午茶”应用</p>
            <div class="lizi"></div>
        </div>
    </div>
</template>
        
<script>
export default {
    
}
</script>
<style lang='less' scoped>
.dingdingWord{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 352px;
        background-image: url("http://img601.yun300.cn/repository/image/ad459a77-e46c-4db0-bf47-bfd4c297c404.jpg?tenantId=214689&viewType=1&k=1655780814000");
        background-size: 100%;
        background-repeat: no-repeat;
    }
    .content{
        width: 66%;
        margin: auto;
        padding-top: 100px;
        .p1{
            font-size: 38px;
            line-height: 52px;
        }
        .aaa{
            color: rgb(255, 82, 25);
            margin-bottom: 16px;
            font-size: 18px;
            letter-spacing: 0;
            line-height: 28px;
            cursor: pointer;
        }
        .lizi{
            width: 100%;
            height: 720px;
            background-image: url("./imgs/444B5339-3B5E-4072-B559-2A3EE5BE4DE4-tuya.png");
            background-repeat: no-repeat;
            background-size: 100%;
            margin-top: 30px;
        }
    }
}
</style>